import { FaImage, FaLink, FaVideo } from "react-icons/fa";
import { SimpleButton } from "../../components/button.jsx/Btn";
import Morevertical from "../../assets/more-vertical.png";
import { useState } from "react";
import { Modal } from "../../components/modal";

export function FilesTable({ files, boards }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [viewMode, setViewMode] = useState("list");

  const OpenModal = () => setIsModalOpen(true);
  const CloseModal = () => setIsModalOpen(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    CloseModal();
  };
  return (
    <div className="space-y-6">
      {/* Files Section */}
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-6">
            <h2 className="text-2xl font-semibold text-gray-900">All Files</h2>

            <div className="flex items-center gap-4">
              <button
                onClick={() => setViewMode("list")}
                className={`flex items-center gap-2 ${
                  viewMode === "list"
                    ? "text-gray-900"
                    : "text-gray-400 hover:text-gray-600"
                }`}
              >
                <span className="text-base">☰</span>
                <span className="text-base font-medium">List View</span>
              </button>
              <button
                onClick={() => setViewMode("board")}
                className={`flex items-center gap-2 ${
                  viewMode === "board"
                    ? "text-gray-900"
                    : "text-gray-400 hover:text-gray-600"
                }`}
              >
                <span className="text-base">⊞</span>
                <span className="text-base font-medium">Board View</span>
              </button>
            </div>
          </div>

          <SimpleButton
            onClick={OpenModal}
            className="bg-[#1234CD] px-6 py-3 rounded-full text-base hover:bg-blue-700 text-white"
          >
            Add new
          </SimpleButton>
        </div>

        {viewMode === "list" ? (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Name
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Owner
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Created on
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Last modified on
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Modified by
                    </th>
                    <th className="text-left py-3 px-6 text-sm font-medium text-gray-500">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {files.map((file) => (
                    <tr
                      key={file.id}
                      className="hover:bg-gray-50"
                    >
                      <td className="py-4 px-6">
                        <div className="flex items-center gap-3">
                          <div className="w-8 h-8 flex items-center justify-center">
                            {/* <span className="text-blue-600 text-sm">📄</span> */}
                            <img
                              src={file.image}
                              alt=""
                            />
                          </div>
                          <span className="text-sm font-medium text-gray-900">
                            {file.name}
                          </span>
                        </div>
                      </td>
                      <td className="py-4 px-6 text-sm text-black">
                        {file.owner}
                      </td>
                      <td className="py-4 px-6 text-sm text-black">
                        {file.createdOn}
                      </td>
                      <td className="py-4 px-6 text-sm text-black">
                        {file.lastModified}
                      </td>
                      <td className="py-4 px-6 text-sm text-black">
                        {file.modifiedBy}
                      </td>
                      <td className="py-4 px-6">
                        <button className="text-blue-600 hover:text-blue-800 text-sm font-medium">
                          Manage file
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          // Board View (new card layout)
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
            {boards.map((board) => (
              <div
                key={board.id}
                className="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow"
              >
                <div className="flex items-start justify-between mb-3">
                  <div className="w-8 h-8">
                    {/* <span className="text-blue-600 text-sm">📄</span> */}
                    <img
                      src={board.image}
                      alt={board.name}
                    />
                  </div>
                  <button className="text-gray-400 hover:text-gray-600">
                    {/* <span className="text-sm">⋯</span> */}
                    <img
                      className=" w-4"
                      src={Morevertical}
                      alt=""
                    />
                  </button>
                </div>
                <h3 className="text-sm font-medium text-gray-900 mb-2 line-clamp-2">
                  {board.name}
                </h3>
                <div className="space-y-1 text-xs text-black">
                  <p className="text-blue-600 font-medium">{board.owner}</p>
                  <p>{board.dateCreated}</p>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Modal */}
        <Modal
          isOpen={isModalOpen}
          onClose={CloseModal}
        >
          <div>
            <form onSubmit={handleSubmit}>
              <p className="text-[#000000] text-xl font-bold">Add file</p>

              <div className="grid grid-cols-2 gap-6">
                <div className="my-2">
                  <label
                    htmlFor="title"
                    className="text-[#000000]"
                  >
                    First Name
                  </label>
                  <input
                    className="w-full text-center border-[#D0D0D0] border-2 outline-none rounded-md p-2"
                    placeholder="Name"
                    id="title"
                    type="text"
                  />
                </div>

                <div className="my-2">
                  <label
                    htmlFor="folder"
                    className="text-[#000000]"
                  >
                    Select Folder
                  </label>
                  <input
                    className="w-full text-center p-2 border-[#D0D0D0] border-2 outline-none rounded-md"
                    placeholder="Choose folder"
                    id="folder"
                    type="text"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label
                  htmlFor="desc"
                  className="text-[#000000]"
                >
                  File description
                </label>
                <textarea
                  id="desc"
                  className="w-full text-center p-4 border-[#D0D0D0] border-2 outline-none rounded-md"
                  placeholder="Enter description"
                />
              </div>

              {/* Radio Group */}
              <p>Share by:</p>
              {["Department", "Level", "Grade", "Position"].map((option) => (
                <div
                  key={option}
                  className="gap-2 py-2 flex"
                >
                  <input
                    type="radio"
                    name="shareBy"
                    id={option}
                    value={option}
                  />
                  <label htmlFor={option}>{option}</label>
                </div>
              ))}

              {/* Upload Section */}
              <p className="text-black font-bold text-sm mt-4">
                Upload Attachment
              </p>

              <div className="flex items-center gap-8 text-sm mt-4">
                <button
                  type="button"
                  className="flex items-center gap-1 text-pink-500 hover:text-pink-600 transition"
                >
                  <FaImage className="w-4 h-4" />
                  Image
                </button>
                <button
                  type="button"
                  className="flex items-center gap-1 text-blue-500 hover:text-blue-600 transition"
                >
                  <FaVideo className="w-4 h-4" />
                  Video
                </button>
                <button
                  type="button"
                  className="flex items-center gap-1 text-orange-500 hover:text-orange-600 transition"
                >
                  <FaLink className="w-4 h-4" />
                  Link
                </button>
              </div>

              <div className="mx-auto justify-center items-center flex">
                <SimpleButton
                  type="submit"
                  className="bg-[#1234CD] mx-auto
                         w-[180px] h-[59px] flex justify-center items-center text-center  mt-6 p-3 hover:bg-blue-700 text-xl text-white"
                >
                  Create
                </SimpleButton>
              </div>
            </form>
          </div>
        </Modal>
      </div>
    </div>
  );
}
